<template>
  <div class="services">
    <HeaderComponent/>

    <main class="content">
      <div class="service-image" v-if="serviceData && serviceData.image">
        <img :src="serviceData.image" :alt="serviceData.title">
      </div>

      <div v-if="serviceData" class="service-detail">
        <h1>{{ serviceData.title }}</h1>

        <div class="service-description">
          <div v-for="(section, index) in serviceData.description" :key="index" class="description-section">
            <h2 v-if="section.title && section.title.trim()">{{ section.title }}</h2>
            <p v-if="section.description && section.description.trim()">{{ section.description }}</p>
          </div>
        </div>

        <div class="service-for-whom" v-if="serviceData.forWho && serviceData.forWho.length">
          <h2 v-if="serviceData.recommendation && serviceData.recommendation.trim()">{{ serviceData.recommendation }}</h2>
          <ul>
            <li v-for="(person, index) in serviceData.forWho" :key="index" v-if="person && person.trim()">{{ person }}</li>
          </ul>
        </div>

        <div class="service-contributions" v-if="serviceData.contributions && serviceData.contributions.length">
          <div class="contribution-section" v-for="(contribution, index) in serviceData.contributions" :key="index" >
            <h2 v-if="contribution.title && contribution.title.trim()">{{ contribution.title }}</h2>
            <template v-if="contribution.description">
              <p v-if="typeof contribution.description === 'string'">{{ contribution.description }}</p>
              <ul v-else-if="Array.isArray(contribution.description)">
                <li v-for="(item, itemIndex) in contribution.description" :key="itemIndex">{{ item }}</li>
              </ul>
            </template>
          </div>
        </div>

        <div class="service-process-container" v-if="serviceData.process && serviceData.process.length" >
          <div class="functionality-row"
               v-if="serviceData.functionality && serviceData.functionality.trim()">
            <h2>{{ serviceData.functionality }}</h2>
            <button
                @click="toggleProcess"
                class="details-button"
            >
              Detalii
            </button>
          </div>

          <div class="service-process" v-if="showProcess || serviceData.alwaysShowProcess" >
            <div v-if="$route.params.name === 'terapie-cuplu'" class="process-paragraph">
              <p v-for="(step, index) in serviceData.process" :key="index" v-if="step.description">
                {{ step.description }}
              </p>
            </div>

            <ul v-else-if="serviceData.alwaysShowProcess">
              <li v-for="(step, index) in serviceData.process" :key="index" v-if="step.description">
                {{ step.description }}
              </li>
            </ul>
            <div v-else class="process-step" v-for="(step, index) in serviceData.process" :key="index" >
              <h3 v-if="step.title && step.title.trim()">{{ step.title }}</h3>
              <p v-if="step.description && step.description.trim()">{{ step.description }}</p>
              <div v-if="step.evaluation && step.evaluation.length">
                <ul>
                  <li v-for="(item, index) in step.evaluation" :key="index" v-if="item.title || item.description">
                    <h3 v-if="item.title && item.title.trim()">{{ item.title }}:</h3>
                    <span v-if="item.description && item.description.trim()">{{ item.description }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="service-process-container" v-if="serviceData.documents && serviceData.documents.length" >
              <div class="functionality-row">
                <h3>Documente</h3>
                <button
                    @click="toggleDocuments"
                    class="details-button"
                    id="documents-details"
                >
                  Detalii
                </button>
              </div>

              <div class="service-process" v-if="showDocuments" >
                <div class="section-documents" v-for="(doc, index) in serviceData.documents" :key="index" >
                  <strong>{{ doc.title }}</strong>
                  <template v-if="doc.description">
                    <p v-if="typeof doc.description === 'string'">{{ doc.description }}</p>
                    <ul v-else-if="Array.isArray(doc.description)">
                      <li v-for="(item, itemIndex) in doc.description" :key="itemIndex">{{ item }}</li>
                    </ul>
                  </template>
                </div>
              </div>
            </div>

            <div class="service-process-container" v-if="serviceData.whyUs && serviceData.whyUs.length" >
              <div class="functionality-row">
                <h3>Avantaje</h3>
                <button
                    @click="toggleWhyUs"
                    class="details-button"
                    id="why-us-details"
                >
                  Detalii
                </button>
              </div>

              <div v-if="showWhyUs" class="service-process">
                <div v-for="(item, index) in serviceData.whyUs" :key="index" class="section-why-us">
                  <strong>{{ item.title }}</strong>
                  <template v-if="item.description">
                    <p v-if="typeof item.description === 'string'">{{ item.description }}</p>
                    <ul v-else-if="Array.isArray(item.description)">
                      <li v-for="(point, pointIndex) in item.description" :key="pointIndex">{{ point }}</li>
                    </ul>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="specialization-sections" v-if="serviceData.specializationSections && serviceData.specializationSections.length" >
          <h2>Servicii specializate</h2>
          <div v-for="(section, index) in serviceData.specializationSections"
               :key="index"
               class="specialization-section"
               :id="section.id">
            <h3 v-if="section.title && section.title.trim()">{{ section.title }}</h3>

            <div class="section-description">
              <div v-for="(desc, descIndex) in section.description" :key="descIndex" v-if="desc.title || desc.description">
                <h4 v-if="desc.title && desc.title.trim()">{{ desc.title }}</h4>
                <p v-if="desc.description && desc.description.trim()">{{ desc.description }}</p>
              </div>
            </div>

            <div class="service-for-whom" v-if="section.forWho && section.forWho.length">
              <h3 v-if="section.recommendation && section.recommendation.trim()">{{ section.recommendation }}</h3>
              <ul>
                <li v-for="(person, idx) in section.forWho" :key="idx" v-if="person && person.trim()">{{ person }}</li>
              </ul>
            </div>

            <div class="section-process-container" v-if="section.process && section.process.length" >
              <div class="functionality-row">
                <h3 v-if="section.functionality && section.functionality.trim()">{{ section.functionality }}</h3>
                <button
                    v-if="section.process && section.process.length"
                    @click="toggleSectionDetails(section.id)"
                    class="details-button"
                >
                  Detalii
                </button>
              </div>

              <div v-if="showSectionDetails[section.id]" class="section-details">
                <div class="section-process">
                  <div v-for="(step, stepIdx) in section.process" :key="stepIdx" class="process-step" v-if="step.title || step.description">
                    <h4 v-if="step.title && step.title.trim()">{{ step.title }}</h4>
                    <p v-if="step.description && step.description.trim()">{{ step.description }}</p>
                  </div>
                </div>

                <div v-if="section.id === 'evaluare-handicap-copii' && section.contributions && section.contributions.length" class="section-contributions">
                  <div v-for="(contribution, contIndex) in section.contributions" :key="contIndex">
                    <h4 v-if="contribution.title">{{ contribution.title }}</h4>
                    <div v-if="contribution.description">
                      <p v-if="typeof contribution.description === 'string'">{{ contribution.description }}</p>
                      <ul v-else-if="Array.isArray(contribution.description)">
                        <li v-for="(item, idx) in contribution.description" :key="idx" v-html="formatItemText(item)"></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-if="section.documents && section.documents.length" class="section-documents">
                  <div v-for="(doc, docIndex) in section.documents" :key="docIndex" v-if="doc.title || doc.description">
                    <h4 v-if="doc.title && doc.title.trim()">{{ doc.title }}</h4>
                    <div v-if="doc.description">
                      <p v-if="typeof doc.description === 'string'">{{ doc.description }}</p>
                      <ul v-else-if="Array.isArray(doc.description)">
                        <li v-for="(item, idx) in doc.description" :key="idx">{{ item }}</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-if="section.whyUs && section.whyUs.length" class="section-why-us">
                  <div v-for="(item, whyIndex) in section.whyUs" :key="whyIndex" v-if="item.title || item.description">
                    <h4 v-if="item.title && item.title.trim()">{{ item.title }}</h4>
                    <div v-if="item.description">
                      <p v-if="typeof item.description === 'string'">{{ item.description }}</p>
                      <ul v-else-if="Array.isArray(item.description)">
                        <li v-for="(listItem, idx) in item.description" :key="idx">{{ listItem }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cta-section">
          <router-link to="/" class="cta-btn">Înapoi la pagina principală</router-link>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import HeaderComponent from "../components/HeaderComponent.vue";

  export default {
    name: 'Services',
    components: {HeaderComponent},
    data () {
      return {
        showProcess: false,
        showDocuments: false,
        showWhyUs: false,
        showSectionDetails: {},
        servicesData: {
          'consiliere-individuala': {
            title: 'Consiliere psihologică individuală',
            image: '',
            description: [
              {
                title: '',
                description: 'Consilierea psihologică individuală este un proces terapeutic personalizat, care se desfășoară într-un cadru sigur și confidențial. Credem că fiecare persoană este unică – în cazul fiecăruia dintre noi zestrea genetică se împletește cu anumite trăsături de personalitate și cu un traseu irepetabil, parcurs din copilărie până la viața de adult.'
              },
              {
                title: '',
                description: 'Consilierea psihologică care are ca scop explorarea, înțelegerea și abordarea problemelor emoționale, cognitive sau comportamentale cu care te confrunți acum, și este o oportunitate de a lucra împreună cu un specialist pentru a dezvolta strategii personalizate, care să te ajute să fii mai rezilient, ceea ce înseamnă să poți face față provocărilor și să îți îmbunătățești calitatea vieții.'
              }
            ],
            recommendation: 'Această formă de terapie este recomandată persoanelor care:',
            forWho: [
              'simt că se confruntă cu stres excesiv sau anxietate.',
              'au dificultăți în gestionarea emoțiilor, cum ar fi furia, vinovăția sau tristețea.',
              'se confruntă cu depresie, lipsa motivației sau stări de apatie.',
              'doresc să își dezvolte încrederea în sine și abilitățile sociale.',
              'au suferit o pierdere semnificativă și au nevoie de sprijin pentru a procesa durerea.',
              'se simt blocați într-o situație sau într-o etapă a vieții lor.',
              'vor să își înțeleagă mai bine tiparele de gândire și comportament'
            ],
          },
          'terapie-cuplu': {
            title: 'Terapie de cuplu',
            image: '',
            description: [
              {
                title: '',
                description: 'Terapia de cuplu este un proces terapeutic dedicat partenerilor care doresc să își îmbunătățească relația, să rezolve conflictele și să își consolideze legătura emoțională. Cu ajutorul unui specialist, puteți explora dinamica relației voastre, pentru a înțelege mai bine nevoile și perspectivele fiecăruia și pentru a dezvolta abilități de comunicare eficientă și de colaborare, în avantajul ambilor parteneri dar și al copiilor, atunci când este cazul'
              }
            ],
            recommendation: 'Această formă de terapie este potrivită pentru cuplurile care:',
            forWho: [
              'se confruntă cu dificultăți de comunicare sau neînțelegeri frecvente.',
              'se confruntă cu probleme legate de încredere, inclusiv infidelitate.',
              'își doresc să gestioneze mai bine conflictele și tensiunile.',
              'au dificultăți în luarea deciziilor importante (căsătorie, copii, carieră).',
              'vor să îmbunătățească intimitatea și apropierea fizică sau emoțională.',
              'se pregătesc pentru schimbări majore în viață (căsătorie, mutare, venirea unui copil).'
            ],
            alwaysShowProcess: true,
            showProcess: false,
            process: [
              {
                title: '',
                description: 'Ședințele de terapie se desfășoară într-un mediu sigur și confidențial, în care ambii parteneri sunt ascultați și respectați. Veți avea ocazia să vă exprimați punctul de vedere și să contribuiți la găsirea soluțiilor, într-un mod care să reflecte nevoile și dorințele fiecăruia'
              }
            ]
          },
          'consiliere-copii-adolescenti': {
            title: 'Consiliere psihologică pentru copii și adolescenți',
            image: '',
            description: [
              {
                title: '',
                description: 'Consilierea psihologică pentru copii și adolescenți este un proces dedicat susținerii tinerilor în fața provocărilor emoționale, comportamentale și sociale cu care se confruntă. Într-un mediu sigur și prietenos, aceștia pot explora gândurile și sentimentele dificile, învățând să-și gestioneze mai bine stările emoționale, să comunice eficient și să-și dezvolte abilitățile necesare pentru a face față dificultăților cu care se confruntă.'
              }
            ],
            recommendation: 'Această formă de consiliere este destinată copiilor și adolescenților care:',
            forWho: [
              'se confruntă cu anxietate, stres sau atacuri de panică.',
              'manifestă dificultăți în adaptarea la școală sau în relațiile cu colegii.',
              'au probleme de comportament, cum ar fi agresivitatea sau retragerea socială.',
              'suferă de lipsă de încredere în sine sau stări de tristețe prelungite.',
              'trebuie să gestioneze schimbări importante în viața lor, cum ar fi divorțul părinților și/sau mutarea la o altă școală sau în alt oraș.',
              'au fost expuși la traume, bullying sau alte experiențe dificile.',
              'au dificultăți în gestionarea emoțiilor sau în luarea deciziilor.'
            ],
            contributions: [
              {
                title: '',
                description: 'De-a lungul anilor, am sprijinit sute de copii și familii pentru gestionarea problemelor psihologice. Este firesc ca, în fața unor situații dificile, părinții să se simtă uneori depășiți. Dacă observi la copilul tău dificultăți emoționale sau de comportament care nu mai pot fi gestionate prin metodele folosite până acum în familia voastră, credem că este important să apelați la un psiholog pentru a primi ajutor specializat.'
              }
            ],
            functionality: 'Cum decurge procesul de consiliere psihologică?',
            process: [
              {
                title: 'Întâlnirea inițială cu părinții',
                description: 'Prima sesiune este dedicată înțelegerii situației copilului și din perspectiva părinților. Discutăm provocările, comportamentele și obiectivele terapiei.'
              },
              {
                title: 'Crearea unui spațiu sigur pentru copil',
                description: 'În timpul ședințelor, copilul sau adolescentul va avea posibilitatea să exploreze liber gândurile și emoțiile, prin discuții și activități psihologice adaptate vârstei'
              },
              {
                title: 'Activități terapeutice',
                description: 'Pentru copii, terapia poate include jocuri, desen sau povestiri terapeutice. Pentru adolescenți, se pune accent pe dialog și tehnici specifice care vizează identificarea și modificarea tiparelor de gândire și comportament dar și îmbunătățirea strategiilor de reglare emoțională.'
              },
              {
                title: 'Colaborarea cu părinții',
                description: 'Periodic, vom discuta progresul și vom oferi recomandări pentru susținerea copilului acasă și la școală.'
              }
            ]
          },
          'psihologie-clinica': {
            title: 'Psihologie clinică',
            image: '',
            description: [
              {
                title: '',
                description: 'Psihologia clinică vizează evaluarea, psihodiagnosticul și intervenția primară în cazul tulburărilor psiho emoționale, pentru toate categoriile de vârstă. Este un domeniu dedicat înțelegerii profunde a problemelor psihologice și a tulburărilor mintale, în vederea stabilirii unui plan de intervenție psihologic și/sau psihiatric personalizat.'
              },
              {
                title: '',
                description: 'Evaluarea clinică se realizează la solicitarea clientului, a familiei acestuia și/sau la recomandarea unui medic specialist neurolog sau psihiatru.'
              }
            ],
            alwaysShowProcess: true,
            process: [
              {
                description: 'Aplicăm scale psihologice și interviuri structurate pentru a evalua sănătatea mintală și nivelul de funcționare cognitivă, emoțională și comportamentală.'
              },
              {
                description: 'Parcurgem procesul de psihodiagnostic pentru tulburări precum anxietatea, depresia, tulburările obsesiv-compulsive, tulburările de alimentație, ADHD, PTSD etc.'
              },
              {
                description: 'Colaborăm cu medici psihiatri pentru o abordare integrată atunci când este necesar.'
              }
            ],
            specializationSections: [
              {
                id: 'evaluare-ces',
                title: 'Evaluare psihologică în vederea întocmirii dosarului de cerințe educaționale speciale (CES) pentru copii',
                description: [
                  {
                    title: '',
                    description: 'Evaluarea psihologică pentru întocmirea dosarului de cerințe educaționale speciale este un proces esențial în sprijinul copiilor care se confruntă cu dificultăți de învățare sau cu alte nevoi educaționale specifice. Aceasta are rolul de a evalua abilitățile cognitive, comportamentale și emoționale ale copilului pentru a stabili necesitatea unor măsuri educaționale speciale. Scopul este de a asigura accesul la un mediu de învățare adaptat nevoilor sale, favorizând o dezvoltare optimă și integrarea în educația de masă sau într-un sistem educativ specializat.'
                  }
                ],
                functionality: 'Cum decurge procesul de evaluare psihologică?',
                process: [
                  {
                    description: 'În interviul inițial cu părinții se obțin informații despre istoricul copilului, dificultățile întâmpinate în viața de zi cu zi și despre comportamentele problematice observate acasă sau la școală. Discutăm despre starea emoțională a copilului și despre recomandările deja făcute de profesori sau alți specialiști.'
                  },
                  {
                    description: 'Se aplică teste specifice pentru a evalua IQ-ul copilului, abilitățile de învățare, memoria, raționamentul logic, capacitatea de concentrare și rezolvarea problemelor.'
                  },
                  {
                    description: 'Analizăm aspecte legate de reglarea emoțională, gestionarea stresului, relaționarea cu alți copii și comportamentele în context școlar și social. De asemenea, se pot aplica chestionare și scale de evaluare a stării emoționale și comportamentale.'
                  },
                  {
                    description: 'Se examinează abilitatea copilului de a interacționa cu semenii, de a respecta norme sociale și de a comunica eficient în diferite contexte. În special pentru copiii cu autism sau ADHD, această evaluare este esențială pentru a înțelege nevoile speciale de adaptare educațională.'
                  },
                  {
                    description: 'Dacă este necesar, colaborăm cu profesori, medici, terapeuți ocupaționali sau logopezi pentru a avea o imagine completă asupra stării copilului și a dificultăților sale educaționale.'
                  }
                ],
                contributions: [
                  {
                    title: 'De ce este importantă această evaluare?',
                    description: [
                      'Acces la sprijin: Rezultatele evaluării permit părinților să solicite servicii de asistență socială, terapii specializate, beneficii financiare sau alte resurse disponibile prin încadrarea copilului în grad de handicap.',
                      'Plan personalizat: Raportul clinic oferă informații utile pentru specialiștii implicați în educația și terapia copilului, contribuind la crearea unui plan personalizat de intervenție.',
                      'Sprijin emoțional pentru familie: Înțelegerea dificultăților copilului ajută părinții să se simtă mai bine informați și susținuți în gestionarea situației.'
                    ]
                  }
                ],
              },
              {
                id: 'evaluare-handicap-copii',
                title: 'Evaluare clinică în vederea încadrării în grad de handicap pentru copii',
                description: [
                  {
                    title: '',
                    description: 'Evaluarea clinică pentru încadrarea în grad de handicap este un proces de psihodiagnostic care are scopul de a identifica dificultățile de dezvoltare, cognitive, emoționale sau comportamentale ale copilului, astfel încât familia să poată beneficia de sprijinul și resursele oferite conform legii.'
                  }
                ],
                recommendation: 'Acest tip de evaluare este necesară copiilor care prezintă:',
                forWho: [
                  'Întârzieri semnificative în dezvoltare (motorie, cognitivă, emoțională, socială).',
                  'Tulburări de spectru autist sau alte tulburări de neurodezvoltare.',
                  'Dificultăți severe de adaptare sau funcționare autonomă.',
                  'Afecțiuni neurologice, genetice sau alte condiții medicale care afectează calitatea vieții.'
                ],
                functionality: 'Cum decurge procesul de evaluare clinică?',
                process: [
                  {
                    title: 'Interviu cu părinții',
                    description: 'Se colectează informații detaliate despre istoricul medical, psihologic și social al copilului. Psihologul va discuta despre comportamentele observate, dificultățile întâmpinate și orice alte aspecte relevante pentru evaluare.'
                  },
                  {
                    title: 'Observația copilului',
                    description: 'În cadrul întâlnirii, psihologul analizează comportamentul copilului, interacțiunea socială, reacțiile emoționale și modul în care răspunde la cerințe simple.'
                  },
                  {
                    title: 'Aplicarea testelor clinice',
                    description: 'Se folosesc teste psihologice validate științific și adaptate pentru copii, care măsoară: Dezvoltarea cognitivă și adaptativă, Abilitățile de comunicare și socializare, Funcționarea emoțională și comportamentală.'
                  },
                  {
                    title: 'Interpretarea rezultatelor',
                    description: 'Pe baza informațiilor obținute, psihologul va evalua severitatea și impactul dificultăților copilului asupra vieții sale și a familiei.'
                  },
                  {
                    title: 'Întocmirea raportului clinic',
                    description: 'La final, se elaborează un raport detaliat care include concluziile evaluării, psihodiagnosticul și recomandările pentru sprijinirea copilului.'
                  }
                ],
                contributions: [
                  {
                    title: 'De ce este importantă această evaluare?',
                    description: [
                        'Acces la sprijin: Rezultatele evaluării permit părinților să solicite servicii de asistență socială, terapii specializate, beneficii financiare sau alte resurse disponibile prin încadrarea copilului în grad de handicap.',
                        'Plan personalizat: Raportul clinic oferă informații utile pentru specialiștii implicați în educația și terapia copilului, contribuind la crearea unui plan personalizat de intervenție.',
                        'Sprijin emoțional pentru familie: Înțelegerea dificultăților copilului ajută părinții să se simtă mai bine informați și susținuți în gestionarea situației.'
                    ]
                  }
                ],
                documents: [
                  {
                    title: 'Documente necesare pentru evaluare',
                    description: [
                      'Pentru a iniția procesul de evaluare, părinții trebuie să aducă:',
                      'Certificatul de naștere al copilului (copie).',
                      'Actele de identitate ale părinților/tutorilor (copie).',
                      'Documente medicale relevante, cum ar fi scrisori medicale, rapoarte anterioare sau rezultate ale investigațiilor.'
                    ]
                  },
                  {
                    title: 'Durata evaluării',
                    description: 'Procesul de evaluare durează aproximativ 1-2 ore, în funcție de complexitatea cazului.'
                  }
                ],
              },
              {
                id: 'evaluare-handicap-adulti',
                title: 'Evaluare psihologică pentru Comisia de evaluare a persoanelor adulte cu handicap',
                description: [
                  {
                    title: '',
                    description: 'Evaluarea psihologică în vederea obținerii certificării pentru handicap sau a pensiei de boală este un proces esențial pentru persoanele adulte care se confruntă cu limitări semnificative ale funcționării fizice, mentale sau psihosociale.'
                  },
                  {
                    title: '',
                    description: 'Psihologul clinician evaluează abilitățile cognitive, emoționale și comportamentale ale adultului, pentru a întocmi un raport detaliat ce va fi utilizat de către Comisia de evaluare a persoanelor adulte cu handicap, în scopul stabilirii măsurilor de sprijin necesare pentru îmbunătățirea calității vieții și integrarea socială a persoanei respective.'
                  }
                ],
                functionality: 'Cum decurge procesul de evaluare psihologică?',
                process: [
                  {
                    description: 'În prima fază a evaluării, are loc un interviu structurat cu persoana evaluată și, dacă este cazul, cu familia acesteia. Se vor colecta informații despre istoricul medical, diagnosticele anterioare, tratamentele urmate și impactul problemelor de sănătate asupra vieții cotidiene - inclusiv nivelul de funcționare socială și profesională.'
                  },
                  {
                    description: 'Psihologul clinician aplică teste standardizate pentru a evalua abilitățile cognitive (memorie, gândire, concentrare, atenție, capacitate de rezolvare a problemelor) și emoționale (reglarea emoțiilor, gestionarea stresului, răspunsuri la traume sau conflicte).'
                  },
                  {
                    description: 'Se analizează modul în care persoana interacționează cu ceilalți, capacitatea de a comunica și de a se integra în societate, cu accent pe comportamentele care pot reflecta dificultăți în gestionarea relațiilor sociale, la locul de muncă sau în activitățile de zi cu zi.'
                  },
                  {
                    description: 'Psihologul clinician evaluează modul în care boala afectează activitățile cotidiene ale persoanei, precum capacitatea de a lucra, de a se îngriji de igiena personală, de a participa la activități sociale sau de a menține relații adecvate cu ceilalți. Se analizează limitările funcționale și emoționale, precum și posibilele strategii de adaptare.'
                  },
                  {
                    description: 'În funcție de complexitatea cazului, se pot solicita informații suplimentare de la medici specialiști (neurologi, psihiatri, terapeuți ocupaționali).'
                  }
                ],
                contributions: [
                  {
                    title: '',
                    description: 'Pe baza rezultatelor evaluării, psihologul clinician întocmește un raport detaliat, care include psihodiagnosticul, descrierea limitărilor funcționale și recomandările aferente. Acest raport este necesar pentru dosarul de cerere adresat Comisiei de evaluare a persoanelor adulte cu handicap.'
                  }
                ]
              }
            ]
          },
          'psihologie-securitate-nationala': {
            title: 'Psihologie aplicată în domeniul securității naționale',
            image: '',
            description: [
              {
                title: '',
                description: 'Evaluarea psihologică pentru obținerea sau prelungirea permisului de port armă este un proces obligatoriu, reglementat de legislația în vigoare, prin care se atestă că persoanele care solicită acest drept sunt apte din punct de vedere psihologic să manipuleze arme letale sau neletale. Scopul acestei evaluări este de a verifica dacă solicitantul dispune de stabilitate emoțională, autocontrol, discernământ și capacitate de a lua decizii responsabile, pentru a preveni riscurile asociate utilizării necorespunzătoare a armelor'
              }
            ],
            recommendation: 'Această evaluare este necesară pentru:',
            forWho: [
              'Persoanele fizice care doresc să obțină permisul de port armă pentru scopuri personale (vânătoare, tir sportiv, autoapărare etc.).',
              'Persoanele care solicită prelungirea valabilității permisului de port armă.',
              'Personalul din instituțiile de apărare, ordine publică și securitate națională, conform cerințelor legale',
              'Cursuri/interviuri'
            ],
            functionality: 'Cum decurge procesul de evaluare psihologică?',
            process: [
              {
                description: 'Psihologul realizează anamneza pentru a înțelege motivația solicitantului, istoricul personal, starea de sănătate mentală și emoțională, precum și nivelul de cunoștințe despre responsabilitățile implicate de manipularea unei arme.'
              },
              {
                description: 'Se folosesc baterii de teste validate științific, adaptate cerințelor pentru portul armelor, care evaluează',
                evaluation: [
                  {
                    title: 'Personalitatea',
                    description: 'stabilitatea emoțională, impulsivitatea, agresivitatea, capacitatea de adaptare.'
                  },
                  {
                    title: 'Statutul cognitiv',
                    description: ' memoria, atenția, gândirea logică și capacitatea decizională.'
                  },
                  {
                    title: 'Capacitatea de autocontrol',
                    description: 'abilitatea de a gestiona stresul, tensiunile și situațiile conflictuale.'
                  }
                ]
              },
              {
                description: 'În timpul evaluării, psihologul observă atitudinea și comportamentul solicitantului pentru a identifica eventuale semne de instabilitate emoțională, neîncredere sau alte aspecte relevante.'
              },
              {
                description: 'Se verifică eventualele antecedente psihiatrice care ar putea reprezenta un risc în manipularea armelor de foc.'
              },
              {
                description: 'La finalul procesului, psihologul avizul în care menționează că solicitantul este apt sau neapt pentru de a deține și utiliza arme.'
              }
            ],
            documents: [
              {
                title: 'Documente necesare pentru evaluare',
                description: [
                  'Actul de identitate (în original).',
                  'Cererea sau documentele care atestă necesitatea evaluării (pentru obținere sau prelungire permis).',
                  'Orice documente relevante privind starea de sănătate, dacă este cazul.'
                ]
              }
            ],
            whyUs: [
              {
                title: 'De ce să ne alegi?',
                description: [
                  'Profesionalism: Utilizăm teste validate și respectăm standardele naționale și internaționale în domeniul evaluării psihologice în domeniul securității și apărării naționale.',
                  'Confidențialitate: Garantăm confidențialitatea completă a informațiilor furnizate pe parcursul procesului de evaluare.',
                  'Promptitudine: Rezultatele și raportul psihologic sunt oferite într-un timp scurt, pentru a răspunde rapid nevoilor tale.'
                ]
              }
            ]
          }
        }
      };
    },
    computed: {
      serviceData () {
        const routeName = this.$route.params.name;
        return this.servicesData[routeName] || null;
      }
    },
    methods: {
      toggleProcess () {
        this.showProcess = !this.showProcess;
      },
      toggleSectionDetails(sectionId) {
        if (!this.showSectionDetails[sectionId]) {
          this.$set(this.showSectionDetails, sectionId, true);
        } else {
          this.showSectionDetails[sectionId] = !this.showSectionDetails[sectionId];
        }
      },
      toggleDocuments () {
        this.showDocuments = !this.showDocuments;
      },
      toggleWhyUs () {
        this.showWhyUs = !this.showWhyUs;
      },
      formatItemText (text) {
        if (text && text.includes(':')) {
          const parts = text.split(':');
          return `<strong>${parts[0]}</strong>:${parts[1]}`;
        }
        return text;
      }
    }
  }
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $hover-color: #1a2b53;
  $text-color: #333;
  $off-white: #f8f8f8;
  $border-light: #eee;

  @media only screen and (min-width: 0px) {
    .services {
      font-weight: 300;
      color: $text-color;
      font-size: 22px;
      line-height: 1.6;
      margin-top: 80px;

      .content {
        max-width: 1000px;
        margin: 40px auto;
        padding: 0 20px;
      }

      .service-detail {
        h1 {
          color: $primary-color;
          font-size: 38px;
          margin-bottom: 30px;
          text-align: center;
          font-weight: bold;
        }

        h2 {
          color: $primary-color;
          font-size: 32px;
          margin: 30px 0 15px;
          text-align: left;
          font-weight: bold;
        }

        h3 {
          color: $primary-color;
          font-size: 28px;
          margin: 20px 0 10px;
          text-align: left;
          font-weight: bold;
        }

        h4 {
          color: $primary-color;
          font-size: 24px;
          margin: 15px 0 10px;
          text-align: left;
          font-weight: bold;
        }
        .service-for-whom > h2{
          text-align: center;
        }
      }

      .service-image {
        max-width: 600px;
        margin: 0 auto 30px;

        img {
          width: 100%;
          border-radius: 6px;
        }
      }

      p {
        font-size: 22px;
        line-height: 1.6;
        margin-bottom: 15px;
        text-align: left;
      }

      ul {
        padding-left: 25px;
        margin-bottom: 25px;
        text-align: left;

        li {
          font-size: 22px;
          line-height: 1.6;
          margin-bottom: 10px;
          text-align: left;
        }
      }

      .service-contributions strong,
      .section-documents strong,
      .section-why-us strong,
      .service-process .section-documents strong,
      .service-process .section-why-us strong,
      .contribution-section strong,
      .section-description strong,
      .description-section strong {
        display: block;
        font-size: 24px;
        margin: 15px 0 10px;
        color: $primary-color;
        text-align: left;
        font-weight: bold;
      }

      .details-button {
        background-color: $primary-color;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 15px;
        cursor: pointer;
        font-size: 22px;
        transition: background-color 0.3s ease;
        width: 100%;

        &:hover {
          background-color: $hover-color;
        }
      }

      .functionality-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 15px;

        h2, h3, h4 {
          margin: 0 0 15px 0;
          width: 100%;
        }

        > h2 {
          font-size: 32px;
        }

        > h3 {
          font-size: 28px;
        }

        > h4 {
          font-size: 24px;
        }
      }

      .service-description,
      .service-contributions {
        margin-bottom: 30px;
        text-align: left;
      }

      .description-section {
        margin-bottom: 20px;
      }

      .contribution-section {
        margin-bottom: 15px;
      }

      .service-process-container {
        margin-bottom: 30px;

        .process-bullet-list {
          ul {
            padding-left: 25px;
            margin-bottom: 25px;
            text-align: left;

            li {
              font-size: 22px;
              line-height: 1.6;
              margin-bottom: 10px;
              text-align: left;
            }
          }
        }
      }

      .section-details {
        margin-top: 15px;
        padding: 15px 0;
        background-color: transparent;
        margin-left: 0;
      }

      .process-step {
        margin-bottom: 20px;
        text-align: left;
      }

      .specialization-sections {
        margin-top: 40px;
        border-top: 1px solid $primary-color;
        padding-top: 30px;
        margin-left: 0;

        > h2 {
          color: $primary-color;
          font-size: 34px;
          margin: 30px 0 25px;
          text-align: center;
          font-weight: bold;
        }
      }

      .specialization-section {
        margin-bottom: 50px;
        padding-bottom: 30px;
        border-bottom: 1px solid $border-light;

        &:last-child {
          border-bottom: none;
        }

        > h3 {
          color: $primary-color;
          font-size: 28px;
          margin: 25px 0 15px;
          text-align: left;
          font-weight: bold;
        }

        .section-description {
          margin-bottom: 20px;
          margin-left: 0;
          text-align: left;
        }

        .section-documents,
        .section-why-us,
        .section-contributions {
          padding: 15px 0;
          border-radius: 4px;
          margin-top: 20px;
          margin-left: 0;
        }
      }

      .service-process {
        .section-documents,
        .section-why-us {
          padding: 15px 0;
          margin-top: 20px;
          margin-left: 0;
        }

        .process-paragraph {
          margin-bottom: 20px;

          p {
            font-size: 22px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: left;
          }
        }
      }

      .cta-section {
        margin-top: 40px;
        padding: 20px 0;
        border-radius: 6px;
        text-align: center;

        p {
          font-size: 22px;
          margin-bottom: 20px;
          text-align: left;
        }

        .cta-btn {
          background-color: $primary-color;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 12px 25px;
          text-decoration: none;
          font-size: 22px;
          transition: background-color 0.3s ease;
          margin-left: 0;
          margin-bottom: 30px;
          display: block;

          &:hover {
            background-color: $hover-color;
          }
        }
      }

      #evaluare-handicap-copii {
        .section-contributions {
          ul {
            list-style-type: none;
            padding-left: 0;
            margin-top: 10px;

            li {
              margin-bottom: 12px;
              line-height: 1.6;
              position: relative;
              text-align: left;

              strong {
                font-weight: bold;
                display: inline;
                font-size: inherit;
                margin: 0;
                color: inherit;
              }
            }
          }
        }

        .section-documents {
          margin-top: 5px;
          padding-top: 0;
        }
      }

      @media (min-width: 768px) {
        .service-detail {
          h1 {
            font-size: 38px;
          }

          h2 {
            font-size: 32px;
          }

          h3 {
            font-size: 28px;
          }

          h4 {
            font-size: 24px;
          }

          .service-for-whom > h2{
            text-align: left;
            font-size: 32px;
          }
        }

        .specialization-sections > h2 {
          font-size: 34px;
        }

        .specialization-section > h3 {
          font-size: 28px;
        }

        .service-contributions strong,
        .section-documents strong,
        .section-why-us strong,
        .contribution-section strong {
          font-size: 24px;
        }

        .cta-section {
          .cta-btn {
            display: block;
            width: auto;
            max-width: 300px;
            text-align: center;
          }
        }

        .functionality-row {
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          h2, h3, h4 {
            margin: 0;
            width: auto;
          }
        }

        .details-button {
          width: auto;
          display: flex;
        }
      }
    }
  }
</style>